import { formatCurrency } from '@maia/utils';
import { Typography } from '../../ui';
import { twMerge } from 'tailwind-merge';
import { BillingUnitDto } from '@maia/shared';

type BigPricingPillProps = (
  | {
      price: number;
    }
  | { priceRaw: string }
) & {
  billingUnit: BillingUnitDto;
  withFromTag?: boolean;
  variant: 'ghost' | 'default';
  size: 'md' | 'lg';
};

export function BigPricingPill(props: BigPricingPillProps) {
  const priceText =
    'price' in props ? formatCurrency(props.price) : props.priceRaw;
  const {
    variant = 'default',
    withFromTag = false,
    size = 'md',
    billingUnit,
  } = props;

  const [priceBeforeComma, priceAfterComma] = priceText.split(',');

  return (
    <div
      className={twMerge(
        'inline-flex px-20 py-4 items-center rounded-24 relative shrink-0 h-fit',
        variant === 'ghost' ? 'bg-transparent px-0' : 'bg-info50',
      )}
    >
      {withFromTag && (
        <Typography
          variant="body-xs"
          weight="regular"
          className="text-primaryMain -mt-[48px] -mr-[32px]"
        >
          Vanaf
        </Typography>
      )}
      <Typography
        variant="body-xs"
        weight="regular"
        className="text-primaryMain"
      >
        <strong className="inline-flex">
          <Typography
            variant={size === 'md' ? 'display4' : 'display3'}
            weight="semibold"
          >
            {priceBeforeComma},
          </Typography>
          <Typography
            variant="body-l"
            weight="semibold"
            className="mt-[4px] -ml-[6px]"
          >
            {priceAfterComma}
          </Typography>
        </strong>{' '}
        <span className="-ml-[6px]">{billingUnit.abbreviation}</span>
      </Typography>
    </div>
  );
}
